import React, { Component } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';

const propTypes = {
  extensionCheckout: PropTypes.object,
  extensionPolicy: PropTypes.object,
  extensionReturnDate: PropTypes.object,
  getRentalCarExtensionCheckout: PropTypes.func,
  getRentalCarExtensionPolicy: PropTypes.func,
  goBack: PropTypes.func,
  isRentalCarInProgress: PropTypes.bool,
  navTo: PropTypes.func,
  purchaseRentalCarExtension: PropTypes.func,
  updateExtensionConfirmationNumber: PropTypes.func,
  updateRentalCarExtensionReturnDate: PropTypes.func,
};

const defaultProps = {
  extensionCheckout: {},
  extensionPolicy: {},
  extensionReturnDate: null,
  getRentalCarExtensionCheckout: () => {},
  getRentalCarExtensionPolicy: () => {},
  goBack: () => {},
  isRentalCarInProgress: false,
  navTo: () => {},
  purchaseRentalCarExtension: () => {},
  updateExtensionConfirmationNumber: () => {},
  updateRentalCarExtensionReturnDate: () => {},
};

class RentalCarExtension extends Component {
  render() {
    const {
      children,
      extensionCheckout,
      extensionPolicy,
      extensionReturnDate,
      getRentalCarExtensionCheckout,
      getRentalCarExtensionPolicy,
      goBack,
      isRentalCarInProgress,
      navTo,
      params,
      policiesById,
      purchaseRentalCarExtension,
      redirect,
      updateExtensionConfirmationNumber,
      updateRentalCarExtensionReturnDate,
    } = this.props;

    return (
      <div className="RentalCarExtension">
        {children &&
          React.cloneElement(children, {
            extensionPolicy: extensionPolicy,
            extensionReturnDate: extensionReturnDate,
            policy: policiesById[params.policyId],
            totals: get(extensionCheckout, 'totals'),
            isRentalCarInProgress,

            getRentalCarExtensionCheckout: getRentalCarExtensionCheckout.bind(
              this,
              this.order
            ),
            goBack: goBack,
            navTo: navTo,
            redirect: redirect,
            purchaseRentalCarExtension: purchaseRentalCarExtension,
            updateExtensionConfirmationNumber: updateExtensionConfirmationNumber,
            updateRentalCarExtensionReturnDate: updateRentalCarExtensionReturnDate,
            getRentalCarExtensionPolicy: getRentalCarExtensionPolicy,
          })}
      </div>
    );
  }
}

RentalCarExtension.propTypes = propTypes;
RentalCarExtension.defaultProps = defaultProps;

export default RentalCarExtension;
